<script>
/*
Everything has a header (except the iframe page)
npx firebase-logging --project=YOUR_PROJECT --freq=1500

What do we need to still do....

A generic 404 page

Signup resume process

    Subscribe: (If they have a subscription we shouldn't show this button)
        -> If they are signed in:
            **A** Take them to the step they left off at
        -> If they are not signed in:
            Take them to create:
                -> If they try and create an account that exists:
                    -> Have them sign in and go to step they left off at

    - Wrap routes in a "are they signed up" wrapper
        - If they have a subscription then we send them back to the home page

    - Subscription wrapper that will help them proceed to the correct step?

    If state === 'needsverify':
        create -> Go to verify (but don't automatially send the email)
        Verify -> stay
        Info -> Verify
        Purchase -> Verify

    if state === 'needsinfo':



    if state === 'needspayment':
        create -> purchase
        verify -> purchase
        purchase -> stay





    States:
        - needsverify
        - needspayment
        - done

        .subscriptionStatus = 'none';




Maybe a fatal/uknown error popup that we put a code in so we can troubleshoot



Website:
    - Actually set read/write permissions for collections in firestore

    - Add 404
    

    - Take care of preroute auth scenarios e.g. not logged in trying to access an authenticated page
        - This includes making sure we handles cases where they end up on a page that doesn't "make sense".
            Like ending up on the verify page well after registation has been completed
            This might be a standard "Oops this page is 404 or something... Go home or contact support"



    - Make sure that we have an active subscription before we allow them to go over to litmos
        - Do something if it isn't active


    - Make sure we don't let them subscribe to the same thing twice.
        - For now once they have subscribed we don't let them go through purchasing page again
        - Bar them subscribing and paying twice

    - Make a better email verification page
        - Change email address during sign up

    - Error handling and displaying information to users
        - Catch as many javascript errors as we can because an uncaught exception can cause the page to not respond

    - Terms page that they agree this subscription. Verbage on the subscription page to 29.99/month

    - Add analytics

    - They sign out of litmos page and redirected back to us.

Scott:
    - Style litmos header and figure that out

Stripe:
    - Complete Stripe registration
    - Template all of stripe's emails so they look like we want them to.

Migration of existing customers:
    - Create Firebase auth accounts for each them with a default password
        - Auto update to set their email as verified
    - Create firestore.User document for them.
        - Make sure to mark them as haaving a subscription
        - flag the user as needing to reset their password.**
    - Switch domains, get Litmos to redirect to us on sign out
    - Notify peeeps
    - .... hope for the best


Post Launch:

- Support for sending emails to customers

- Notify if they payment has gone bad

- A "My Account" page where they can change their stuff:

    - Change payment information
    - Pull subscription information from Stripe
        - Pull subscription
    - At least a message that say sto contact support if they wish to cancel

- Stripe webooks

Done:
- Contact support page
    -> We need to add a contact form

- Coupons
    - None stripe signup if coupon makes it free for life???
    - Show information about what the coupon provides during checkout
- Password reset and email recovery
    https://github.com/firebase/functions-samples/blob/master/email-confirmation/functions/index.js








*/

import qs from 'qs';
import { writable } from 'svelte/store';
import firebase from './firebase';
import { app, firestore, IN_DEV, LOCAL } from './firebase';
import { onMount } from 'svelte';
import * as user from './user.js';
import * as utils from './utils.js';
import { curUser } from './user.js';
import { push } from 'svelte-spa-router'

import Routes from './routes.svelte';

import Signup from './components/signup.svelte';
import Signin from './components/signin.svelte';
import Payment from './components/payment.svelte';

import ModalChoose from './components/modal_choose.svelte';


const LOCAL_FUNCS = true; // set to true to test cloud functions locally (false, dev env calls production funcs)
window.CloudCall = function(name, params={}, anon=false)
{
    let url;
    if (LOCAL)
    {
        url = `http://${window.location.hostname}:5001/summit-dev-8cc54/us-central1/main`;
    }
    else
    {
        if (IN_DEV)
        {
            url = 'https://us-central1-summit-dev-8cc54.cloudfunctions.net/main';
        } 
        else
        {
            url = 'https://us-central1-summit-e1fe1.cloudfunctions.net/main';
        }
    }

    console.log("API call", url);
    return new Promise(async (resolve, reject) =>
    {
        let body = {action:name, payload:params};
        if (!anon)
        {
            let cu = firebase.auth().currentUser;
            if (cu)
                body.auth = await cu.getIdToken();
        }
        body = JSON.stringify(body);
        fetch(url, {method:'POST', headers:{'Content-Type':'application/json'}, body}).then(async resp =>
        {
            let body = await resp.json();
            resolve(body);
        }).catch(err => resolve({error:err.message}));
    });
}

let modal = null;
let modalCloseCB = null;
let userBtnEl = null; // bound to the user button so we can position the dialog
window.MODAL_OK = 0; // normal close
window.MODAL_ESCAPE = 1;
window.MODAL_OVERLAY = 2;
window.MODAL_CANCEL = 3;
// common routine for showing a modal dialog. props are attached to the component's exports. The dialog can be
// closed by calling HideDialog(code), where code is one of the MODAL_* constants above. By default, the modal
// can be called by pressing Escape or clicking outside the dialog (resulting in MODAL_ESCAPE and MODAL_OVERLAY
// codes), but the modal can export a CanClose(withCode) function and return false to prevent it. Once the modal
// has closed, if a closeCB(code, comp) callback was provided, it is called (it receives the component instance
// before it is destroyed, in case it has data that the caller needs). If events is provided, it is a mapping of
// event names to handlers for events emitted by the modal component.
// Note that ShowModal and HideModal are attached to the window to make them globally accessible.
window.ShowModal = function(comp, props={}, closeCB=null, events={})
{
    if (modal != null)
    {
        console.log('ERROR: tried to create a modal when one is already open!');
        console.log(JSON.stringify(comp));
        return;
    }
    modalCloseCB = closeCB;
    try {
        modal = new comp({target:document.getElementById('globalModal'), props});
    }
    catch (e)
    {
        console.log('ERROR while instantiating modal component :', e.name, e.message, e.stack);
        return;
    }

    for (let [eventName, cb] of Object.entries(events))
        modal.$on(eventName, cb);
    return modal;
}

window.HideModal = function(closeCode=MODAL_OK)
{
    if (modal == null)
    {
        //console.log('ERROR: tried to destroy a modal when no modal is open!');
        return;
    }

    if (modal.CanClose != null && !modal.CanClose(closeCode))
        return;

    if (modalCloseCB)
    {
        try {
            modalCloseCB(closeCode, modal);
        } catch (e) { console.log('ERROR in modal closeCB:', e.name, e.message, e.stack); }
    }
    modalCloseCB = null;
    modal.$destroy();
    modal = null;
}

// prompts the user to make a choice among a few different buttons, where each button
// is a string to use as the label or an object with at least a .label member that is
// used for the button text. The closeCB is called with a single parameter - null if the
// user canceled the dialog, otherwise either the label of the button clicked if strings
// were passed in, or the object whose corresponding button was clicked.
window.Choose = function(text, buttons, closeCB, allowCancel=true)
{
    if (!buttons || !buttons.length) return;
    let wrap = typeof buttons[0] == 'string';
    if (wrap)
        buttons = buttons.map(label => ({label}));
    ShowModal(ModalChoose, {text, buttons, allowCancel}, (closeCode, comp) =>
    {
        let ret = comp.choice;
        if (ret && wrap)
            ret = ret.label;
        if (closeCB) // might just be a 'hey, FYI' dialog
            closeCB(ret);
    });
}

window.Alert = function(text, afterCB=null)
{
    Choose(text, ['Ok'], afterCB);
}

window.Dang = function(text)
{
    window.Alert(text);
}

function OnModalOverlayClicked(e)
{
    e.preventDefault();
    HideModal(MODAL_OVERLAY);
}



let something = false;
onMount(() =>
{
    //
    utils.BeginLogSession();

    /*
    setTimeout(() => {
        document.body.classList.remove('is-preload');
    }, 1000);
    */
})

curUser.subscribe((u) =>
{
    if (u && u.auth && u.id)
    {
        // update the last time they came here
        firestore.collection('User').doc(u.id).update({lastmod:utils.Now(), lastSignIn:utils.Now()});
    }
    else
    {
    }

});


</script>


<Routes />

<!-- Footer -->
  <footer id="footer" style="margin-top: auto;">
    <ul class="icons" style="display: flex; flex-direciton: row; margin: 0 auto 1em auto;">
      <li><a href="https://www.facebook.com/Summitbrainandspine" class="icon brands fa-facebook-f"><span class="label">Facebook</span></a></li>
      <li><a href="https://www.instagram.com/summitbrainandspine/?hl=en" class="icon brands fa-instagram"><span class="label">Instagram</span></a></li>
      <li><a href="mailto:www.summitmedicalinstitute.info.com" class="icon solid fa-envelope"><span class="label">Email</span></a></li>
    </ul>
    <ul class="copyright" style="display: flex; flex-direciton: row; margin: 1em auto 0 auto;">
      <li style="line-height: 1.8;">3000 Triumph Blvd., Suite 330 Lehi, UT 84043</li>
      <li style="line-height: 1.8;">&copy; Summit Medical Institute</li>
    </ul>
  </footer>

<div id="overlay" on:click={OnModalOverlayClicked} on:contextmenu={OnModalOverlayClicked}
     style="display:{(modal != null) ? 'grid':'none'};"
     on:keydown|stopPropagation={() => {}} on:keyup|stopPropagation={() =>{}}>
    <div id="globalModal" style="display:grid" on:click|stopPropagation="{()=>{}}" on:contextmenu|stopPropagation="{()=>{}}">
    </div> <!-- this is the element into which modals are rendered -->
</div>




<style>
@import 'main.css';

#footer {
  font-size: 11pt;
  background-color: #4c4c4c;
  padding: 2.0em 1em;
}

@media screen and (max-width: 1680px) {
  #footer {
    padding: 2.0em 1em;
}}

@media screen and (max-width: 1280px) {
  #footer {
    padding: 2.0em 1em;
}}

@media screen and (max-width: 980px) {
  #footer {
    padding: 2.0em 1em;
}}

@media screen and (max-width: 736px) {
  #footer {
    padding: 2.0em 1em;
}}

@media screen and (max-width: 480px) {
  #footer {
    padding: 2.0em 1em;
}}

#footer ul.icons {
  margin-bottom: 1em !important;
}

@media screen and (max-width: 1280px) {
#footer .copyright {
    margin-top: 3.5em;
    padding-top: 1.125em;
}}

/*
@import 'global.css';
@import 'header.css';
@import 'modals.css';


#header ul li a:hover{color: #68b5cf;}
#header ul li a:active{color: #68b5cf;}
#header > h1 {margin: 0 0 0 0;}

#footer {
  background-color: #1c1d1e;
  color: #fff;
  padding: 3.0em 0px;
}
#footer h3 {color: #fff;}
#footer ul.labeled-icons li .icon {
    border-color: #fff;
}
#footer .copyright {
  margin-top: 2.5em;
  padding-top: 2.5em;
}
#footer h4 {color: #68b5cf;}
.icon.alt:before {text-shadow: none;}

#footer a:hover {color: #68b5cf !important;}
#footer a {color: #fff !important;}
*/

</style>
